import '../css/app.less';

import { initRoutes } from '@eidellev/adonis-stardust/client';
initRoutes();

import 'lite-youtube-embed';
import initTippy from './modules/init-tippy';
import './modules/lazysizes';
import './modules/modal';

import './modules/cookiebot';
import './modules/userway';
import './modules/ie-banner';
import './modules/set-css-variables';
import './modules/scrollmagic';
import './modules/nav';
import './modules/autocomplete';
import './modules/smooth-scrolling';
import './modules/date-picker';
import './modules/forms';
import './modules/checkout';
import './modules/slider';
import './modules/slider-carousel-collection';
import './modules/buttons';
import './modules/product-grid-collection-carousel';
import './modules/birthstones';
import './modules/share-button';
import './modules/product-cards';
import './modules/parallax';
import './modules/scroll-video';
import './modules/countdown';
import './modules/featured-content-brand-subnav';
import './modules/contact-v2';
import './modules/corporate-gifts';
import './modules/trunk-show-booking';
import './modules/price-filter-bar';
import initTagHeuerInquiry from './modules/tag-heuer-inquiry-form';



import './modules/global-cart';

import { mapsExists, initMaps } from './modules/google-maps';
import styles from './modules/json/raffi-snazzy-maps.json';

import './modules/language-switcher';
import './modules/search-personalization';
import './modules/request-purchase';

document.addEventListener('DOMContentLoaded', async () => {
    initTippy();
    initTagHeuerInquiry();  // ← add it here
    if (document.querySelector('.js-map') != null && !mapsExists()) {
        await initMaps(styles);
    }
});
